import React from "react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import BookingDotComInsert from "../components/booking-dot-com-insert";
import { MDXProvider } from "@mdx-js/react";
import TableOfContents from "./table-of-contents";

const shortcodes = { BookingDotComInsert, TableOfContents };

export default function ContentRender({
  className = "",
  children,
  tableOfContents,
}) {
  const TOC = (props) => <TableOfContents tableOfContents={tableOfContents} />;

  return (
    <div id="remark-render" className={className}>
      <MDXProvider components={Object.assign({}, shortcodes, { TOC })}>
        <MDXRenderer>{children}</MDXRenderer>
      </MDXProvider>
    </div>
  );
}
